import { AuthorizationService } from './services/authorization.service';
import { OsmService } from './services/osm.service';
import { MysqlService } from './services/mysql.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LoginRouteGuard, AdminRouteGuard, NotLoginRouteGuard } from './route-guard';
import { UserService } from './services/user.service';
import { DecimalPipe, registerLocaleData, DatePipe } from '@angular/common'


import localeIt from '@angular/common/locales/it';
import { FilterByFileTypePipe } from './pipes/filter-by-file-type.pipe';
import { ReportComponent } from './report/report.component';
import { ServerityPipe } from './pipes/serverity.pipe';
import { OpenWeatherService } from './services/open-weather.service';
import { PipesModule } from './pipes/pipes.module';
import { XlsButtonComponent } from './components/xls-button/xls-button.component';
import { ProgramComponent } from './menu/demo/program/program.component';
import { AgGridModule } from 'ag-grid-angular'
import { CommesseDialogDialogComponent } from './menu/options/commesse/dialog/commesse-dialog/commesse-dialog.component';
import { CommesseDialogDialogManualiComponent } from './menu/options/commesse/dialog/commesse-dialog-manuali/commesse-dialog-manuali.component';
import { DialogCheckComponent } from './menu/automotive/perizie/dialog/dialog-check/dialog-check.component';
import { GridEditComponent } from './components/grid-edit/grid-edit.component';
import { LicenseManager } from 'ag-grid-enterprise';

registerLocaleData(localeIt, 'it');

LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-071600}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{General_group_S.r.l.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_January_2026}____[v3]_[01]_MTc2ODQzNTIwMDAwMA==454e92e6c8d98e827189e6dc88c271e9");


@NgModule({ declarations: [
        AppComponent,
        AdminLayoutComponent,
        ReportComponent,
        ServerityPipe,
        ProgramComponent,
        CommesseDialogDialogManualiComponent,
        CommesseDialogDialogComponent,
        DialogCheckComponent,
        GridEditComponent,
    ],
    exports: [
        ServerityPipe,
        XlsButtonComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        FormsModule,
        ComponentsModule,
        RouterModule,
        AppRoutingModule,
        AgGridModule, //.withComponents([GridEditComponent]),
        PipesModule], providers: [
        MysqlService,
        DatePipe,
        LoginRouteGuard,
        AdminRouteGuard,
        NotLoginRouteGuard,
        UserService,
        DecimalPipe,
        FilterByFileTypePipe,
        OsmService,
        AuthorizationService,
        { provide: LOCALE_ID, useValue: 'it' },
        ServerityPipe,
        OpenWeatherService,
        PipesModule,
        provideHttpClient(withInterceptorsFromDi()),
    ] })



export class AppModule {

}


